/* LinkPickerButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import LinkIcon from '@atlaskit/icon/core/link';
import { useFireAnalyticsEvent } from '../../hooks/useAnalyticsEvent';
import messages from './messages';
export var LinkPickerButton = function LinkPickerButton(_ref) {
  var editorApi = _ref.editorApi,
    promptType = _ref.promptType;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginState(editorApi, ['hyperlink']),
    hyperlinkState = _useSharedPluginState.hyperlinkState;
  var fireAnalyticsEvent = useFireAnalyticsEvent();
  var handleClick = useCallback(function () {
    if (editorApi) {
      var _editorApi$hyperlink;
      var showLinkToolbarAction = (_editorApi$hyperlink = editorApi.hyperlink) === null || _editorApi$hyperlink === void 0 ? void 0 : _editorApi$hyperlink.commands.showLinkToolbar(INPUT_METHOD.QUICK_INSERT);
      if (showLinkToolbarAction) {
        editorApi.core.actions.execute(showLinkToolbarAction);
      }
    }
    fireAnalyticsEvent({
      payload: {
        action: ACTION.CLICKED,
        actionSubject: ACTION_SUBJECT.BUTTON,
        actionSubjectId: ACTION_SUBJECT_ID.AI_PROMPT_LINK_PICKER_BUTTON,
        attributes: {
          promptType: promptType
        },
        eventType: EVENT_TYPE.UI
      }
    });
  }, [editorApi, fireAnalyticsEvent, promptType]);

  // The editor can be wrapped in a component that process keyboard events,
  // but we don't need to propagate `Enter`, `Space`, and `Tab` key event to the editor.
  var stopPropagationForActionKeys = useCallback(function (event) {
    if (['Enter', ' ', 'Tab'].includes(event.key)) {
      event.stopPropagation();
    }
  }, []);
  return /*#__PURE__*/React.createElement(IconButton, {
    isTooltipDisabled: false,
    label: formatMessage(messages.label),
    testId: "link-picker-button",
    icon: LinkIcon,
    isSelected: !!(hyperlinkState !== null && hyperlinkState !== void 0 && hyperlinkState.activeLinkMark),
    spacing: "compact",
    appearance: "subtle",
    onClick: handleClick,
    onKeyDown: stopPropagationForActionKeys,
    onKeyUp: stopPropagationForActionKeys
  });
};